
import React from 'react';
import { Helmet } from 'react-helmet';
import ArticleTemplate from '@/components/ArticleTemplate';
import { Link } from 'react-router-dom';
import {
  UlosottoIntroSection,
  UlosottoProcessSection,
  VelallisenOikeudetSection,
  UlosotonValttaminenSection,
  UlosotonToimintaSection,
  UlosotonVaikutuksetSection,
  UlosottoFaqSection,
  UlosottoSummarySection
} from '@/components/articles/ulosotto';

const UlosotonAbcArticlePage: React.FC = () => {
  // Define image URL for sharing - käytetään oikeaa kuvan URL-osoitetta
  const imageUrl = "https://lainasampo.fi/lovable-uploads/a462fcc8-fd52-4832-9cc4-6ee763d29736.png";
  const fullUrl = "https://lainasampo.fi/artikkelit/ulosoton-abc-kaikki-mita-sinun-tulee-tietaa-ulosotosta";
  
  return (
    <>
      <Helmet>
        <title>Ulosoton ABC - Kaikki mitä sinun tulee tietää ulosotosta | Lainasampo</title>
        <meta 
          name="description" 
          content="Ulosotto voi olla pelottava ja monimutkainen prosessi. Tämä opas selittää selkeästi ulosoton perusteet, prosessin vaiheet, velallisen oikeudet ja vaihtoehdot."
        />
        <link rel="canonical" href={fullUrl} />
        
        {/* OpenGraph tags for social sharing */}
        <meta property="og:title" content="Ulosoton ABC - Kaikki mitä sinun tulee tietää ulosotosta" />
        <meta property="og:description" content="Ulosotto voi olla pelottava ja monimutkainen prosessi. Tämä opas selittää selkeästi ulosoton perusteet, prosessin vaiheet, velallisen oikeudet ja vaihtoehdot." />
        <meta property="og:image" content={imageUrl} />
        <meta property="og:url" content={fullUrl} />
        <meta property="og:type" content="article" />
        
        {/* Twitter card tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Ulosoton ABC - Kaikki mitä sinun tulee tietää ulosotosta" />
        <meta name="twitter:description" content="Ulosotto voi olla pelottava ja monimutkainen prosessi. Tämä opas selittää selkeästi ulosoton perusteet, prosessin vaiheet, velallisen oikeudet ja vaihtoehdot." />
        <meta name="twitter:image" content={imageUrl} />
      </Helmet>

      <ArticleTemplate
        title="Ulosoton ABC - Kaikki mitä sinun tulee tietää ulosotosta"
        description="Ulosotto voi olla pelottava ja monimutkainen prosessi. Tämä opas selittää selkeästi ulosoton perusteet, prosessin vaiheet, velallisen oikeudet ja vaihtoehdot sekä tarjoaa konkreettisia neuvoja ulosottotilanteessa."
        date="2025-04-05"
        readTime="10 min"
        category="lainaoppaat"
        imageUrl={imageUrl}
        relatedArticles={[
          {
            id: "lainan-ottamisen-opas-2025",
            title: "Lainan ottamisen opas 2025",
            slug: "lainan-ottamisen-opas-2025",
            description: "Kattava yleisopas lainan prosessista, kilpailutuksesta ja parhaiden tarjousten hyödyntämisestä."
          },
          {
            id: "yhdistelylaina-opas",
            title: "Yhdistelylaina-opas lainojen yhdistämiseen",
            slug: "yhdistelylaina-opas-lainojen-yhdistamiseen",
            description: "Miten yhdistää useat lainat yhdeksi edullisemmaksi kokonaisuudeksi."
          },
          {
            id: "kulutusluotto-vertailu",
            title: "Kulutusluottojen vertailu - Säästä korkokuluissa",
            slug: "kulutusluottojen-vertailu-saasta-korkokuluissa",
            description: "Vertaile kulutusluottoja ja säästä jopa satoja euroja korkokuluissa."
          }
        ]}
        content={
          <div className="prose max-w-none">
            <UlosottoIntroSection />
            <UlosottoProcessSection />
            <VelallisenOikeudetSection />
            <UlosotonValttaminenSection />
            <UlosotonToimintaSection />
            <UlosotonVaikutuksetSection />
            <UlosottoFaqSection />
            <UlosottoSummarySection />
          </div>
        }
      />
    </>
  );
};

export default UlosotonAbcArticlePage;
